import { getAddress } from 'utils/addressHelpers'
import tokens from './tokens'
import { SUPRA_MAINNET_CHAIN_ID, SUPRA_TESTNET_CHAIN_ID } from './chains'
import { PoolConfig, PoolCategory } from './types'

const pools: PoolConfig[] = [
  {
    // MasterChef pool 0: stake xTOON, earn TOON. sousId must equal the MasterChef pid.
    sousId: 0,
    stakingToken: tokens.xbow,
    earningToken: tokens.bow,
    contractAddress: {
      [SUPRA_TESTNET_CHAIN_ID]: '',
      [SUPRA_MAINNET_CHAIN_ID]: '0x882A0f0BCe7b703DfE06D142A69f4920EB954465', // MasterChef
    },
    poolCategory: PoolCategory.COMMUNITY,
    harvest: true,
    tokenPerSecond: '0', // replaced by the MasterChef rate in fetchPoolsTotalStaking
    sortOrder: 0,
    isFinished: false,
  },
  {
    // SmartChef: stake xTOON, earn PAW. 2,000,000 PAW over 730 days, 2026-10-13 15:00 UTC to 2028-10-12 15:00 UTC
    sousId: 1,
    stakingToken: tokens.xbow,
    earningToken: tokens.paw,
    contractAddress: {
      [SUPRA_TESTNET_CHAIN_ID]: '',
      [SUPRA_MAINNET_CHAIN_ID]: '0x1ac42750b57c0563486Eb757F0b034F57C350431', // SmartChef
    },
    poolCategory: PoolCategory.COMMUNITY,
    harvest: true,
    tokenPerSecond: '0.031709791983764586', // PAW per second: 2,739.73 PAW per day
    sortOrder: 1,
    isFinished: false,
  },
]

// A pool shows once its contract address is filled in: the pools' data comes from one multicall, so a pool without
// an address would break every pool
export default pools.filter((pool) => getAddress(pool.contractAddress))
